/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const GET_GOOGLE_PAY_CLIENT_ID = 'MFE/PAYMENT/GET/GOOGLEPAY/CLIENTID';
export const CLEAR_GOOGLE_PAY_CLIENT_ID = 'MFE/PAYMENT/CLEAR/GOOGLEPAY/CLIENTID';
export const LOAD_GOOGLE_PAY_CLIENT_ID = 'MFE/PAYMENT/LOAD/GOOGLEPAY/CLIENTID';
export const PLACE_ORDER_GOOGLE_PAY = 'MFE/PAYMENT/PLACEORDER/GOOGLEPAY';
export const USE_ANOTHER_GOOGLE_PAY_ACCOUNT = 'MFE/PAYMENT/CHANGE/GOOGLE/PAYMENT';

export default {};
